
import CacheService from "@/common/cache.service";

import {
	INITIALIZE_INVOICE,
	PRELOAD_INVOICE_DATA,
	LOCK_AND_LOAD_DATA,
	LOAD_INVOICE_DATA_CACHE
} from "./actions.type";
import {
	SET_INVOICE_DATA,
	SET_INVOICE_CACHE,
	CLEAR_INVOICE_CACHE,
	SET_INVOICE_EDITABLE,
	SET_BILLING_INFO,
	SET_STASH_DATA,
	SET_PAYMENT_DETAILS,
	SET_PAYMENT_METHOD,
	SET_ACTION,
	SET_ORDER_ID,
	SET_ISSUER_ID,
	SET_FINANCING_OPTION,
	CLEAR_INVOICE,
	CLEAR_BILLING,
	CLEAR_PAYMENT,
	CLEAR_STASH
} from "./mutations.type";

const state = {
	// SPECIFIC STATE DATA
	invoice: {
		id: "",
		amount: "",
		payment_country: "",
		payment_currency: "",
		type:"",
		amount_payable:"",
	},
	editable: {
		invoice: true,
		amount: true,
		payment_country: true,
		payment_currency: true,
		type: false,
		amount_payable: false
	},
	billing_address: {
		Name: "",
		Email: "",
		Address: "",
		City: "",
		Region: "",
		Country: "",
		PostalCode: "",
		Phone: "",
		NationalIdentifier: "",
		BirthDate: ""
	},
	stashed: {},
	payment_details: {},
	payment_method: {},
	financing_selected: {},
	issuer: "",
	required_action: {},
	order_id: ""
};

const getters = {
	invoice: state => state.invoice,
	invoice_editable: state => state.editable,
	billing: state => state.billing_address,
	stashed: state => state.stashed,
	payment_details: state => state.payment_details,
	payment_method: state => state.payment_method,
	action: state => state.required_action,
	order_id: state => state.order_id,
	issuer: state => state.issuer,
	financing_selected: state => state.financing_selected
};

const actions = {
	[INITIALIZE_INVOICE](context, params){
		context.state.currency = context.rootState.merchant.merchant.Currency;
	},
	[LOCK_AND_LOAD_DATA](context, params){
		var editable = context.state.editable;
		var data = context.state.invoice;

		switch(params.type){
			case 'amount':
				CacheService.set_data('invoice_amount', params.data);
				editable.amount = false;
				data.amount = params.data;
				break;
			case 'invoice':
				CacheService.set_data('invoice_id', params.data);
				editable.invoice = false;
				data.id = params.data;
				break;
			case 'country':
				CacheService.set_data('invoice_country', params.data);
				editable.payment_country = false;
				data.payment_country = params.data;
				break;
			case 'type':
				CacheService.set_data('invoice_type', params.data);
				editable.type = false;
				data.type = params.data;
				break;
			case 'currency':
				CacheService.set_data('invoice_currency', params.data);
				editable.payment_currency = false;
				data.payment_currency = params.data;
				break;
			case 'amountPayable':
				CacheService.set_data('invoice_payable', params.data);
				editable.amount_payable = false;
				data.amount_payable = params.data;
				break;
		}

		context.commit(SET_INVOICE_EDITABLE, editable);
		context.commit(SET_INVOICE_DATA, data);
	},
	[PRELOAD_INVOICE_DATA](context, params){
		// Validate strings
		var invoice = (params.invoice !== undefined ? String(params.invoice) : '');
		var amount = (params.amount !== undefined ? params.amount : '');
		var country = (params.country !== undefined ? params.country : '');
		var currency = (params.currency !== undefined ? params.currency : '');
		var type = (params.type !== undefined ? params.type : '');
		var amountPayable = (params.amountPayable !== undefined ? params.amountPayable : '');

		context.commit(SET_INVOICE_DATA, {
			id: invoice,
			amount: amount,
			payment_country: country,
			type: type,
			payment_currency: currency,
			amount_payable: amountPayable
		});
		context.commit(SET_INVOICE_CACHE, {
			id: invoice,
			amount: amount,
			payment_country: country,
			type: type,
			payment_currency: currency,
			amount_payable: amountPayable
		});
		context.commit(SET_INVOICE_EDITABLE, { 
			invoice: (invoice != '' ? false : true),
			amount: (amount != '' ? false : true),
			payment_country: (country != '' && country !== undefined ? false : true),
			type: (type != '' && type !== undefined ? false : true),
			payment_currency: (currency != '' && currency !== undefined ? false : true),
			amount_payable: (amountPayable != '' && amountPayable !== undefined ? false : true)
		});
	},
	[LOAD_INVOICE_DATA_CACHE](context, params){
		// check if cached data exists
		console.log("load cache");
		let id = '';
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_id'))){
			id = CacheService.get_data('invoice_id');
		}
		let type = '';
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_type'))){
			type = CacheService.get_data('invoice_type');
		}
		let amount = '';
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_amount'))){
			amount = CacheService.get_data('invoice_amount');
		}
		let amount_payable = '';
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_payable'))){
			amount_payable = CacheService.get_data('invoice_payable');
		}
		let country = '';
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_country'))){
			country = CacheService.get_data('invoice_country');
		}
		let currency = '';
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_currency'))){
			currency = CacheService.get_data('invoice_currency');
		}
		if (currency === "" && country !== "") {
			// use country to get currency
			const countryObj = context.getters.countries.find(({ code: c }) => c === country);
			if(countryObj) currency = countryObj.currency;
		}else if(currency !== ""){
			const countryObj = context.getters.countries.find(({ currency: c }) => c === currency);
			if(countryObj) currency = countryObj.currency;
		}else{
			currency = "";
		}
		let editable = {
			invoice: true,
			amount: true,
			payment_country: true,
			payment_currency: true
		};
		if(![undefined, '', 'null', null].includes(CacheService.get_data('invoice_editable'))){
			editable = JSON.parse(CacheService.get_data('invoice_editable'));
			if (!editable.invoice) {
				editable.invoice = true;
			}
			if (!editable.amount) {
				editable.amount = true;
			}
			if (!editable.payment_country) {
				editable.payment_country = true;
			}
			if (!editable.payment_currency) {
				editable.payment_currency = true;
			}
		}

		let invoice_data = {
			"id": id,
			"amount": amount,
			"payment_currency": currency,
			"payment_country": country,
			"type": type,
			"amount_payable": amount_payable
		};

		// Set invoice data if it does
		context.commit(SET_INVOICE_DATA, invoice_data);
		context.commit(SET_INVOICE_EDITABLE, editable);
	}
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
	[SET_ACTION](state, action) {
		state.required_action = action;
	},
	[SET_INVOICE_EDITABLE](state, status) {
		state.editable = status;
		CacheService.set_data('invoice_editable', JSON.stringify(status));
	},
	[SET_FINANCING_OPTION](state, financing) {
		state.financing_selected = financing;
	},
	[SET_ORDER_ID](state, order_id) {
		state.order_id = order_id;
	},
	[SET_ISSUER_ID](state, issuer_id) {
		state.issuer = issuer_id;
	},
	[SET_INVOICE_DATA](state, invoice_details) {
		state.invoice = invoice_details;
		state.billing_address.Country = invoice_details.payment_country;
	},
	[SET_BILLING_INFO](state, billing_address) {
		Object.keys(billing_address).forEach(key => {
			if(billing_address[key] !== undefined) {
				state.billing_address[key] = billing_address[key];
			}
		})
	},
	[SET_STASH_DATA](state, stash) {
		state.stashed = stash;
	},
	[SET_PAYMENT_DETAILS](state, payment_details) {
		state.payment_details = payment_details;
	},
	[SET_PAYMENT_METHOD](state, payment_method) {
		state.payment_method = payment_method;
	},
	[SET_INVOICE_CACHE](state, data){
		CacheService.set_data('invoice_id', data.id || '');
		CacheService.set_data('invoice_amount', data.amount || '');
		CacheService.set_data('invoice_currency', data.payment_currency || '');
		CacheService.set_data('invoice_type', data.type || '');
		CacheService.set_data('invoice_payable', data.amount_payable || '');
		// CacheService.set_data('invoice_country', data.payment_country || '');
	},
	[CLEAR_INVOICE_CACHE](){
		CacheService.clear_data('invoice_id');
		CacheService.clear_data('invoice_amount');
		CacheService.clear_data('invoice_currency');
		CacheService.clear_data('invoice_country');
		CacheService.clear_data('invoice_editable');
		CacheService.clear_data('invoice_type');
		CacheService.clear_data('invoice_payable');
	},
	[CLEAR_INVOICE](state) {
		if(state.editable.invoice){
			state.invoice.id = '';
		}
		if(state.editable.amount){
			state.invoice.amount = '';
		}
		if(state.editable.amount_payable){
			state.invoice.amount_payable = '';
		}
		if(state.editable.payment_currency){
			state.invoice.payment_currency = '';
		}
		if(state.editable.payment_country){
			state.invoice.payment_country = '';
		}
		if(state.editable.type){
			state.invoice.type = '';
		}
	},
	[CLEAR_BILLING](state) {
		state.billing_address = {
			Name: "",
			Email: "",
			Address: "",
			City: "",
			Region: "",
			Country: (state.editable.payment_country?'':state.billing_address.Country),
			PostalCode: "",
			Phone: "",
			NationalIdentifier: "",
			BirthDate: ""
		};
	},
	[CLEAR_PAYMENT](state) {
		state.payment_details = {};
		state.payment_method = {};
		state.order_id = "";
		state.issuer = "";
		state.financing_selected = {};
	},
	[CLEAR_STASH](state) {
		state.stashed = {};
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};
